import { Ref } from '@nuxtjs/composition-api';
import { defineStore } from 'pinia';

import productsInRangeGql from '~/customQueries/productsInRange';
import { ProductInterface, ProductReview } from '~/modules/GraphQL/types';

interface ProductPageState {
  rawReviews: ProductReview[] | null,
  rawRangeProducts: ProductInterface[] | null,
}

const getReviewItems = (review): ProductReview[] => review?.reviews?.items || [];
const getRangeItems = (data) => data?.products?.items?.[0] || [];

export const useProductPageStore = defineStore('productPage', {
  state: (): ProductPageState => ({
    rawReviews: null,
    rawRangeProducts: null,
  }),
  actions: {
    async loadReviews(product: Ref<ProductInterface>) {
      if (product.value.review_count === 0) {
        this.rawReviews = [];
        return;
      }

      const { data } = await this.$nuxt.app.$vsf.$magento.api.productReview({
        filter: {
          sku: {
            eq: product.value.sku,
          },
        },
        pageSize: product.value.review_count || 1,
      });

      const items = data?.products?.items || [];

      const baseReviews = Array.isArray(items) ? items[0] : items;
      this.rawReviews = getReviewItems(baseReviews);
    },
    async loadProductsInRange(skus: number[]) {
      const { data } = await this.$nuxt.app.$vsf.$magento.api.customQuery({
        query: productsInRangeGql,
        queryVariables: {
          pageSize: 12,
          currentPage: 1,
          filter: {
            sku: {
              in: skus,
            },
          },
        },
      });

      this.rawRangeProducts = getRangeItems(data);
    },
  },
  getters: {
    reviews(state) {
      return state.rawReviews;
    },
    productsInRange(state) {
      return state.rawRangeProducts;
    },
  },
});
